/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Subscription = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        store: {
            type: 'StoreEnum',
            isRequired: true,
        },
        productId: {
            type: 'string',
            isRequired: true,
        },
        purchaseDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        expirationDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        cancelDate: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date-time',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        priceAmountMicros: {
            type: 'number',
            isRequired: true,
        },
        currencyCode: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
